import React from 'react'
import { useNavigate } from 'react-router-dom';
import "./TeamCards.css"


function TeamCardBox({
    icon,
    heading,
    content,
}) {
  const paragraphs = content.split('\n').map((paragraph, index) => <p key={index} className='body-paragraph my-1'>{paragraph}</p>);
  return (
    <div className="team-card-box py-4">
    <div className="service-card-info">
      
      <div className="profile-info px-2 d-flex flex-column gap-1 text-center ">
          <img src={icon} alt='card-icon' className='card-round-icon' />
          <h3 className='body-heading mt-3' style={{fontSize:"24px"}}>{heading}</h3>
          <p className="body-paragraph px-1">{paragraphs}</p>

          <a href='https://truelifewellnessphysio.janeapp.com/' target='blank'> 
            <button className='genral-btn'>
              Book An Appointment
            </button>
          </a>
          
      </div>
     
    </div>
</div>
  )
}

export default TeamCardBox